import MonitorIcon from '@icons/monitor.svg';
import styles from './MaintenanceBanner.module.scss';
import { CloseIcon } from '@ds-icons';
import { useEffect, useRef, useState } from 'react';

const MaintenanceBanner: React.FC = () => {
  const [shouldShowBanner, setShouldShowBanner] = useState(false);
  const [bannerMessage, setBannerMessage] = useState('');
  const bannerRef = useRef<HTMLDivElement>(null);

  const showBanner = () => {
    setShouldShowBanner(true);
    document.body.classList.add('maintenance-banner-visible');
  };

  const hideBanner = () => {
    setShouldShowBanner(false);
    document.body.classList.remove('maintenance-banner-visible');
    document.documentElement.style.setProperty('--banner-height', '0px');
  };

  useEffect(() => {
    const fetchBannerMessage = async () => {
      try {
        const response = await fetch(window.FN_CONFIG.BANNERCONTENT_PATH);
        if (response.ok) {
          const text = await response.text();
          // Check if response has content before parsing as JSON
          if (text.trim()) {
            try {
              const data = JSON.parse(text);
              if (data.message) {
                setBannerMessage(data.message);
                showBanner();
              }
            } catch (jsonError) {
              console.error('Invalid JSON in deployment.json:', jsonError);
            }
          } else {
            // Empty response is not an error, just no banner to show
            console.log('Empty deployment.json - no maintenance banner to display');
          }
        } else {
          console.error('Failed to fetch deployment.json:', response.status, response.statusText);
        }
      } catch (error) {
        console.error('Error fetching deployment.json:', error);
      }
    };

    fetchBannerMessage();
  }, []);

  useEffect(() => {
    if (shouldShowBanner && bannerRef.current) {
      const bannerHeight = bannerRef.current.offsetHeight;
      document.documentElement.style.setProperty('--banner-height', `${bannerHeight}px`);
    }
  }, [shouldShowBanner]);

  if (shouldShowBanner && bannerMessage) {
    return (
      <div ref={bannerRef} className={styles['maintenance-banner']}>
        <div className="flex items-center gap-[10px]">
          <img className={styles['monitor-icon']} src={MonitorIcon} />
          <span className={styles['maintenance-text']}>{bannerMessage}</span>
        </div>
        <img className={styles['close-icon']} src={CloseIcon} onClick={hideBanner} />
      </div>
    );
  }

  return null;
};

export default MaintenanceBanner;
